/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_6_CmdInputs */

const en_mk_loop_6_cmd = /** @type {(inputs: Mk_Loop_6_CmdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`task approve · wave next`)
};

const id_mk_loop_6_cmd = /** @type {(inputs: Mk_Loop_6_CmdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`task approve · wave next`)
};

/**
* | output |
* | --- |
* | "task approve · wave next" |
*
* @param {Mk_Loop_6_CmdInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_6_cmd = /** @type {((inputs?: Mk_Loop_6_CmdInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_6_CmdInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_6_cmd(inputs)
	return en_mk_loop_6_cmd(inputs)
});